import { TIconProps } from './utils';

export const MenuDataIconActive = ({ className = '' }: TIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='31'
    height='32'
    viewBox='0 0 31 32'
    fill='none'
    className={className}
  >
    <path
      d='M20 21H25'
      stroke='url(#paint0_linear_18_26)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.3333 28.6405H2.01124C1.45275 28.6405 1 28.1877 1 27.6292V27.6292V27.555C1 27.1637 1.11481 26.7809 1.33021 26.4542L1.55791 26.1088C1.63024 25.9991 1.7132 25.8968 1.8056 25.8033L2.19379 25.4108C2.28659 25.3169 2.38846 25.2325 2.49789 25.1587L3.16877 24.7064C3.27821 24.6327 3.38008 24.5482 3.47288 24.4544L3.77099 24.1529C3.92267 23.9996 4.09815 23.8717 4.29065 23.7744L5.33333 23.2472L6.53882 22.6377C6.62394 22.5946 6.71203 22.5577 6.80242 22.5273L7.66667 22.236L8.41112 21.985C8.58072 21.9278 8.74187 21.8482 8.89027 21.7481L9.66667 21.2247L9.78465 21.1452C10.3361 20.7734 10.6667 20.1519 10.6667 19.4868V18.191V17.3101C10.6667 17.0027 10.5958 16.6993 10.4595 16.4237L10.3333 16.1685L9.85591 15.4444C9.73067 15.2544 9.63876 15.0444 9.58415 14.8235L9.47805 14.3944C9.38491 14.0176 9.15515 13.6889 8.83333 13.4719V13.4719C8.51152 13.255 8.28176 12.9262 8.18861 12.5494L8.0239 11.8832C8.00801 11.8189 7.9852 11.7566 7.95586 11.6973L7.90191 11.5881C7.76115 11.3034 7.81655 10.9608 8.03987 10.735V10.735C8.22216 10.5506 8.29539 10.2847 8.23317 10.033L8 9.08989L7.7672 8.38364C7.7006 8.18161 7.66667 7.97025 7.66667 7.75752V7.38855C7.66667 7.17582 7.7006 6.96446 7.7672 6.76243L8 6.05618L8.28109 4.91919C8.31582 4.77872 8.36568 4.64244 8.42982 4.51273L8.66667 4.03371L9.11318 3.35641C9.25851 3.13597 9.44605 2.94648 9.66498 2.79889L10.3333 2.34831L11.0439 1.86926C11.2354 1.74017 11.4478 1.64521 11.6717 1.58861L12.6667 1.33708L13.3558 1.10477C13.5617 1.03539 13.7775 1 13.9947 1H14.4984C15.0327 1 15.5448 1.21379 15.9204 1.59371L16 1.67416L16.5271 2.2072C16.6199 2.30105 16.7218 2.38548 16.8312 2.45925L17.6667 3.02247L18.0427 3.21259C18.2352 3.30992 18.4107 3.43775 18.5623 3.59113L18.7726 3.80376C18.9232 3.95607 19.0484 4.13159 19.1433 4.3236L19.3333 4.70787L19.6667 5.7191L19.8995 6.42535C19.9661 6.62738 20 6.83874 20 7.05147V7.42044C20 7.63317 19.9661 7.84453 19.8995 8.04656L19.7672 8.44782C19.7006 8.64985 19.6667 8.86122 19.6667 9.07394V9.20564C19.6667 9.35225 19.6433 9.49793 19.5974 9.63717L19.5109 9.89952C19.4019 10.2302 19.4874 10.594 19.7322 10.8415V10.8415C19.9038 11.015 20 11.2492 20 11.4933V11.5421C20 11.7029 19.9629 11.8615 19.8917 12.0056L19.3333 13.1348L19.1187 13.569C19.0401 13.728 18.9352 13.8745 18.8105 14.0006V14.0006C18.5068 14.3077 18.3333 14.7254 18.3333 15.1573V15.1573V16.1685V16.8427M15.3333 28.6405V29C15.3333 30.1046 16.2288 31 17.3333 31H28C29.1046 31 30 30.1046 30 29V18.8427C30 17.7381 29.1046 16.8427 28 16.8427H18.3333M15.3333 28.6405V18.8427C15.3333 17.7381 16.2288 16.8427 17.3333 16.8427H18.3333'
      stroke='url(#paint1_linear_18_26)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_18_26'
        x1='19.9749'
        y1='21.5068'
        x2='27.3145'
        y2='21.5068'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.28779' stopColor='#B36BFF' />
        <stop offset='0.859375' stopColor='#5A75FF' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_18_26'
        x1='0.854689'
        y1='16.2055'
        x2='43.4244'
        y2='16.2055'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.19899' stopColor='#B36BFF' />
        <stop offset='0.859375' stopColor='#5A75FF' />
      </linearGradient>
    </defs>
  </svg>
);
